;(function ($, window) {
    'use strict';
    $(document).ready(function(){

        var searchIsOpen = false;
        var keepHeader = false;
        var indexResultFocus = 0;

        var $searchInput = null;
        var $searchOverlay = $("#search-overlay");
        var $artistsList = $("#artists");
        var $searchNoResults = $("#search-no-results");
        var $searchLoading = $("#search-loading");
        var $searchContent = $("#search-content");

        var $results = $("#search-results");
        var $resultsBestResult = $("#search-results-best-result");
        var $resultsEvents = $("#search-results-events");
        var $resultsArtists = $("#search-results-artists");
        var $resultsPlaces = $("#search-results-places");
        var $resultsViewAll = $('#search-view-all-results');

        $searchContent.perfectScrollbar();

        var resetDisplay = function(){
            $searchLoading.hide();
            $searchNoResults.hide();
            $resultsBestResult.hide();
            $resultsEvents.hide();
            $resultsArtists.hide();
            $resultsPlaces.hide();
            $resultsViewAll.hide();
            $results.find('.item').remove();
            indexResultFocus = 0;
            setTimeout(function () {
                $searchContent.perfectScrollbar('update');
            }, 200);
        };
        resetDisplay();

        $("body").on('click', '*[launch-search]', function(){ //when the search link is clicked...
            var pos = getPosition($(this));

            var $input = $(this).find('input[type="text"]');
            if($input.length){
                $input.attr('autocomplete', 'off');
                launchSearch($input);
            }else{
                launchSearch();
            }
        });

        var getPosition = function($element){
            var offset = $element.offset();
            var posY = offset.top - $(window).scrollTop();
            var posX = offset.left - $(window).scrollLeft();
            var width = $element.outerWidth(true);
            var height = $element.outerHeight(true);

            return {
                "left": posX,
                "top": posY,
                "right": $(window).width()-(posX+width),
                "bottom": $(window).height()-(height),
                "width": width,
                "height": height
            };
        };

        window.addEventListener("keydown",function (e) {
            if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
                e.preventDefault();
                launchSearch();
            }
        });

        var launchSearch = function($input){
            if(typeof $input == 'undefined'){
                $("#search-topbar").show();
                $searchInput = $("#hidden-search");
                keepHeader = false;
                launchSearchAnimation();
            }else if(!$input.is($searchInput)){
                $("#search-topbar").hide();
                keepHeader = true;
                launchSearchAnimation();
                $searchInput = $input;
            }else{
                return;
            }

            $searchInput.focus(); //give the hidden input box focus
            $('#search-filter input[type="checkbox"]').prop('checked', true);
            resetDisplay();

            //when the user pushes a key whilst the input box has focus...
            $searchInput.bind('input', function(e){
                var latestQuery = $searchInput.val();
                updateResults(latestQuery);
            });

            //$searchOverlay.on('click', function(e){ //when the search overlay is clicked...
            //    $searchInput.focus(); //give the hidden input box focus
            //});
        };

        var getTopHeader = function(){
            var posHeader = getPosition(($('.header-tiny').is(':visible'))?$('.header-tiny'):$('.header'));
            return (posHeader.top < 0?0:posHeader.top)+posHeader.height;
        }

        var saveScrollPos = 0;
        var launchSearchAnimation = function(){
            var top = (keepHeader)?getTopHeader():0;
            saveScrollPos = $(window).scrollTop();

            $searchOverlay.css({
                'top': top,
                'bottom': 0,
                'opacity': 0
            }).show().animate({"opacity": 1}, 100); //show the search overlay

            $('#wrapper').addClass(keepHeader?'blur-exclude-header':'blur');
            $('#wrapper').addClass('no-scroll');
            $('#wrapper').css({
                'top': '-'+saveScrollPos+'px'
            });
            $(document).trigger('scroll').trigger('resize');
        }

        var quitSearch = function(){
            if(jqxhr && jqxhr.readyState != 4){
                jqxhr.abort();
            }
            if($searchInput){
                $searchOverlay.animate({"opacity": 0}, 100, function(){ //...animate it's opacity to 0...
                    $(this).hide().css("opacity", 1); //...hide it (so the user can click the elements behind it again) and reset its opacity
                    $('#wrapper').removeClass('no-scroll blur blur-exclude-header');
                    $('#wrapper').css({
                        'top': ''
                    });

                    $('html, body').scrollTop(saveScrollPos);
                    saveScrollPos = 0;

                    $(document).trigger('scroll').trigger('resize');
                });
                $searchInput.blur(); //remove focus from the hidden input
                $searchInput.val('');
                $searchInput.unbind('input');
                $searchInput = null;
            }
            $searchOverlay.unbind('click');
            keepHeader = false;
        };

        $('.search-close').on('click', function(){
            quitSearch();
        });

        $('[side-panel-interaction]').on('click', function(){
            quitSearch();
        });

        $(document).keyup(function(e) {
            if (e.keyCode == 27) { // Echap
                event.preventDefault(); // Prevent default (disable the back button behavior)
                quitSearch();
            }
        });

        // NAVIGATION


        var setFocusOnItem = function(index){
            $results.find('.item').removeClass('active');

            if(index <= 0){
                indexResultFocus = 0;
                $searchInput.focus();
                var strLength= $searchInput.val().length;
                console.log(strLength);
                $searchInput[0].setSelectionRange(strLength, strLength);
                return;
            }

            var nbItems = $results.find('.item').length;
            if(index > nbItems){
                index = nbItems;
            }

            indexResultFocus = index;

            var elemActive = $results.find('.item').eq(indexResultFocus-1);
            elemActive.addClass('active');
            $searchContent
                .scrollTop(elemActive.offset().top - $searchContent.offset().top + $searchContent.scrollTop() - 200)
                .perfectScrollbar('update');
        };

        //$(document).keydown(function(event) {
        //    if (event.which == 13) {
        //        event.preventDefault();
        //        $searchInput.parents('form').eq(0).submit();
        //    }
        //});

        $(document).keydown(function(e) {
            switch(e.keyCode){
                case 13: // ENTER
                    if(indexResultFocus == 0){
                        return;
                    }
                    event.preventDefault(); // Prevent default (disable the back button behavior)
                    var url = $results.find('.item').eq(indexResultFocus-1).find('a').eq(0).attr('href');
                    window.location.href = url;
                    break;
                case 38: // UP
                    setFocusOnItem(indexResultFocus-1);
                    break;
                case 40: // DOWN
                    setFocusOnItem(indexResultFocus+1);
                    break;
            };
        });

        var jqxhr, timeoutId, counter = 0;
        var updateResults = function(latestQuery){

            if(latestQuery.length > 0){ //if there is a query to process...

                if(jqxhr && jqxhr.readyState != 4){
                    jqxhr.abort();
                }

                // Increment counter to maintain separate versions
                counter++
                var thisCounter = counter;
                clearTimeout(timeoutId);
                timeoutId = setTimeout(function () {
                    var jqxhr = $.ajax({
                            url: getUrl('business/autocomplete/'+latestQuery),
                            cache: true,
                            beforeSend: function( xhr ) {
                                resetDisplay();
                                $searchLoading.show();
                            }
                        })
                        .done(function(data) {

                            var noResults = true;

                            if (counter != thisCounter) {
                                return;
                            }

                            var events = [];
                            if(typeof data.regroupements.results !== 'undefined' && data.regroupements.results.length > 0){
                                noResults = false;
                                events = data.regroupements.results;
                            }
                            if(typeof data.events.results !== 'undefined' && data.events.results.length > 0){
                                noResults = false;
                                events = events.concat(data.events.results);
                            }

                            if(events.length > 0){ //if the php script returns a result...
                                noResults = false;
                                $("#search-results-events").show(); //show the results container
                                refreshFigure(events, 'event', $('#search-results-events'));
                            }
                            if(typeof data.artists.results !== 'undefined' && data.artists.results.length > 0){
                                noResults = false;
                                $("#search-results-artists").show(); //show the results container
                                refreshFigure(data.artists.results, 'artist', $('#search-results-artists'));
                            }
                            if(typeof data.places.results !== 'undefined' && data.places.results.length > 0){
                                noResults = false;
                                $("#search-results-places").show(); //show the results container
                                refreshFigure(data.places.results, 'place', $('#search-results-places'));
                            }
                            if(typeof data.bestResult.results !== 'undefined' && data.bestResult.results.length > 0){
                                noResults = false;
                                $("#search-results-best-result").show(); //show the results container
                                refreshFigure(data.bestResult.results, '', $('#search-results-best-result'));
                            }

                            if(typeof data.nbEvents.count !== 'undefined' && data.nbEvents.count > 0){
                                $('#search-view-all-results').show();
                                $('#search-view-all-results .count').html(data.nbEvents.count);
                                $('#search-view-all-results a').attr('href', getUrl("recherche?query="+data.nbEvents.query));
                            }

                            if(noResults == true){
                                $searchNoResults.show();
                            }else{
                                refreshFilter();
                                ImagesLazy.addImages($searchContent.find('img.lazy'));
                            }
                            $searchLoading.hide();
                        })
                        .fail(function() {
                            $searchLoading.hide();
                        })
                        .always(function() {
                            setTimeout(function () {
                                $searchContent.perfectScrollbar('update');
                            }, 200);
                        });

                }, 300);

            }else{
                clearTimeout(timeoutId);
                if(jqxhr && jqxhr.readyState != 4){
                    jqxhr.abort();
                }
                resetDisplay();
            }
        };

        var correspondances = function(item){
            if(item.image == ''){
                item.image = getImageDefaultByType(item._type);
            }else{
                item.image = getAsset(item.image);
            }

            switch(item._type){
                case 'place':
                    return {
                        image: {
                            url: item.image,
                            urlDefault: getImageDefaultByType(item._type),
                        },
                        title: item.name,
                        subtitle: (item.nb_event > 0)?item.nb_event+" évènements":"Aucun évènement",
                        description: item.city+" ("+item.zip_code+")",
                        tags: [],
                        url: urlLegacy+item.url
                    };
                case 'artist':
                    return {
                        image: {
                            url: item.image,
                            urlDefault: getImageDefaultByType(item._type),
                        },
                        title: item.name,
                        subtitle: (item.nb_show > 0)?item.nb_show+" date"+((item.nb_show > 1)?'s':''):"Aucune date",
                        description: "",
                        tags: [],
                        url: urlLegacy+item.url
                    };
                case 'regroupement':
                    return {
                        image: {
                            url: item.image,
                            urlDefault: getImageDefaultByType(item._type),
                        },
                        title: item.name,
                        date: {start: item.date_start, end: item.date_end},
                        description: (item.nb_event > 0)?item.nb_event+" évènement"+((item.nb_event > 1)?'s':''):"Aucune évènement",
                        tags: [Translator.trans(item.genre, {}, 'override_db')],
                        url: urlLegacy+item.url
                    };
                case 'event':
                    return {
                        image: {
                            url: item.image,
                            urlDefault: getImageDefaultByType(item._type),
                        },
                        title: item.name,
                        date: {start: item.date_start, end: item.date_end},
                        description: item.place_name+" - "+item.city,
                        tags: [Translator.trans(item.genre, {}, 'override_db')],
                        url: urlLegacy+item.url
                    };
                case 'show':
                    return {
                        image: {
                            url: item.image,
                            urlDefault: getImageDefaultByType(item._type),
                        },
                        title: item.name,
                        date: {start: item.date_start, end: item.date_end},
                        description: item.place_name+" - "+item.city,
                        tags: [Translator.trans(item.genre, {}, 'override_db')],
                        url: urlLegacy+item.url
                    };
            }
            return item;
        };

        var refreshFigure = function(items, className, element){
            var filtered = [];
            for (var key in items) {
                filtered.push(correspondances($.extend(true, {}, items[key])));
            }

            var templateScript = $("#search-list-items-template").html();
            var template = Handlebars.compile(templateScript);
            Handlebars.registerPartial("date", $("#date-template").html());
            var compiledHtml = template({items: filtered, class: className});
            element.after(compiledHtml);
        };


        // FILTERS
        var refreshFilter = function () {
            $('#search-filter input[type="checkbox"]').each(function(){
                var $items = $('#search-results .item.'+$(this).data('items'));
                if($(this).is(":checked")) {
                    $items.show();
                    if($items.length > 0){
                        $($(this).data('group-title')).show();
                    }
                }else{
                    $items.hide();
                    $($(this).data('group-title')).hide();
                }
            });
        };

        $('#search-filter input[type="checkbox"]').on('change', function(){
            refreshFilter();
        });

        $(window).on('resize', function(e){
            if((keepHeader)){
                setTimeout(function(){
                    $searchOverlay.css({'top': getTopHeader()});
                }, 400);
            }
        });
    });
})(jQuery, window);